import React, { forwardRef, ReactNode } from 'react'
import styled from 'styled-components'

const ToolbarContainer = styled.div`
  position: sticky;
  top: 64px;
  left: 0;
  z-index: 900;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: inherit;
  width: 100%;
  background-color: inherit;
`

const CollapsibleSection = styled.div`
  margin-bottom: 10px;
  @media (max-width: 768px) {
    display: none;
  }
`

const PersistentSection = styled.div`
  
`

interface StickyToolbarProps {
  persistent?: ReactNode
  collapsible?: ReactNode
}

const StickyToolbar = forwardRef<HTMLDivElement, StickyToolbarProps>(
  ({ persistent, collapsible }, ref) => {
    return (
      <ToolbarContainer>
        <div ref={ref}>
          <CollapsibleSection>{collapsible}</CollapsibleSection>
          {persistent && <PersistentSection>{persistent}</PersistentSection>}
        </div>
      </ToolbarContainer>
    )
  }
)

export default StickyToolbar